<template>
  <div class="ranks-dropdown" :class="{ readonly }" ref="dropdownRef">
    <div class="dropdown-control" @click="toggleDropdown">
      <template v-if="selectedRanks.length">
        <rank
          v-for="rank in selectedRanksObjects"
          :key="rank.value"
          :skillRating="rank.skillRating"
          class="selected-rank-icon"
        />
      </template>
      <span v-else class="placeholder">Limit by Rank (optional)</span>
      <fa-icon icon="sort-down" class="icon" />
    </div>

    <transition name="fade">
      <div class="dropdown-menu" v-if="isOpen">
        <div
          class="dropdown-option"
          v-for="rank in ranks"
          :key="rank.value"
          @click.stop="toggleRank(rank.value)"
        >
          <!-- Checkbox purely visual -->
          <input type="checkbox" :checked="selectedRanks.includes(rank.value)" readonly />
          <rank :skillRating="rank.skillRating" class="rank-icon" />
          <span class="label">{{ rank.label }}</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'RanksDropdown',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
      ranks: [
        { value: 'bronze', label: 'Bronze', skillRating: 1499 },
        { value: 'silver', label: 'Silver', skillRating: 1999 },
        { value: 'gold', label: 'Gold', skillRating: 2499 },
        { value: 'platinum', label: 'Platinum', skillRating: 2999 },
        { value: 'diamond', label: 'Diamond', skillRating: 3499 },
        { value: 'masters', label: 'Masters', skillRating: 3999 },
        { value: 'grandmaster', label: 'Grandmaster', skillRating: 5000 },
      ],
    };
  },
  computed: {
    selectedRanks() {
      return this.value;
    },
    selectedRanksObjects() {
      return this.ranks.filter(r => this.selectedRanks.includes(r.value));
    },
  },
  methods: {
    toggleDropdown() {
      if (this.readonly) {
        return;
      }
      this.isOpen = !this.isOpen;
    },
    toggleRank(value) {
      if (this.readonly) {
        return;
      }
      const updated = this.selectedRanks.includes(value)
        ? this.selectedRanks.filter(v => v !== value)
        : [...this.selectedRanks, value];
      this.$emit('change', updated);
    },
    handleClickOutside(event) {
      if (this.$refs.dropdownRef && !this.$refs.dropdownRef.contains(event.target)) {
        this.isOpen = false;
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  unmounted() {
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>

<style scoped lang="scss">
@use "@/styles/styles.scss" as *;

.ranks-dropdown {
	position: relative;
	text-align: left;
	font-family: Arial;

	&.readonly {

		.dropdown-control {
			cursor: not-allowed;
			background: $disabled-control-bg;
            color: $disabled-control-text;

			.placeholder {
				color: $disabled-control-text;
			}
		}
	}

	.dropdown-control {
		background: white;
		border: 1px solid $dark-blue;
		border-radius: 4px;
		padding: 8px 10px;
		box-sizing: border-box;
		cursor: pointer;
		position: relative;
		user-select: none;
		color: $dark-brown;
		height: 38px;

		.placeholder {
			color: $medium-gray-alt;
			font-size: 1em;
		}

		.selected-rank-icon {
			margin-right: 6px;
			display: inline-flex;
			justify-content: center;
			align-items: center;
		}

		.icon {
			position: absolute;
			right: 10px;
			top: 9px;
			color: $dark-blue;
		}
	}

	.dropdown-menu {
		position: absolute;
		top: 100%;
		left: 0;
		width: 100%;
		background: white;
		border: 1px solid $dark-blue;
		border-radius: 4px;
		margin-top: 5px;
		z-index: 20;
		max-height: 250px;
		overflow-y: auto;
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);

		.dropdown-option {
			display: flex;
			align-items: center;
			padding: 7px 10px;
			cursor: pointer;
			gap: 8px;
			justify-content: center;

			input[type='checkbox'] {
				width: 16px;
				height: 16px;
				margin: 0;
				cursor: pointer;
				accent-color: $dark-green;
			}

			.rank-icon {
				display: inline-flex;
				justify-content: center;
				align-items: center;
			}

			.label {
				color: $dark-brown;
				flex: 1;
				font-size: 0.9em;
			}
		}
	}
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.15s ease;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}
</style>
